import { handleActions } from 'redux-actions'
import { IPublishedMessage } from '../types/message'
import { SET_PUBLISHED_MESSAGE } from './internalMessagesActions'

export interface IInternalMessagesState {
  publishedMessage: IPublishedMessage | null
}

const initialState: IInternalMessagesState = {
  publishedMessage: null,
}

export default handleActions<IInternalMessagesState, IPublishedMessage | null>(
  {
    [SET_PUBLISHED_MESSAGE]: (state, { payload }) => ({
      ...state,
      publishedMessage: payload,
    }),
  },
  initialState,
)
